import { render, staticRenderFns } from "./AdminTable.vue?vue&type=template&id=003233cc&scoped=true&"
import script from "./AdminTable.vue?vue&type=script&lang=js&"
export * from "./AdminTable.vue?vue&type=script&lang=js&"
import style0 from "./AdminTable.vue?vue&type=style&index=0&id=003233cc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "003233cc",
  null
  
)

export default component.exports